<template>
    <div class="container p-3 pt-5 my-4 border in-border-header">
        <div class="section-header bg-white">
            {{ $t('label.using_switch') }}
        </div>

        <div v-if="loading" class="text-center p-3">
            در حال بارگذاری...
        </div>

        <div v-else-if="!allow_user_switching" class="alert alert-warning mt-3">
            این قابلیت برای این درگاه فعال نیست
        </div>

        <div v-else>
            <div id="switching_message_div"></div>
            <form @submit.prevent="save" id="switching_setting_form">
                <kt-row id="first_row">
                    <kt-form-group>
                        <div style="padding-right: 35px" class="custom-control custom-switch"
                             id="user_switching_status-div">
                            <input
                                type="checkbox"
                                class="custom-control-input"
                                id="user_switching_status"
                                name="user_switching_status"
                                v-model="switching_status"
                            >
                            <label class="custom-control-label" for="user_switching_status">
                                {{ switching_status ? $t('label.active') : $t('label.inactive') }}
                            </label>
                        </div>
                    </kt-form-group>
                </kt-row>

                <kt-row v-if="!switching_status">
                    <kt-col lg="12" md="12" sm="12"
                            v-for="(psp, index) in active_psp_list"
                            :key="index"
                            class="mb-5"
                    >
                        <kt-form-label :for="'priority_' + (index + 1)">
                            {{ $t('label.priority') + (index + 1) }}
                        </kt-form-label>
                        <kt-form-select
                            v-model="terminal_priorities[(index + 1)]"
                            class="form-control"
                            :name="'priority_' + (index + 1)"
                            :id="'priority_' + (index + 1)"
                        >
                            <option
                                v-for="(psp_name, idx) in active_psp_list"
                                :key="idx"
                                :value="psp_name"
                                :selected="terminal_priorities[(index + 1)] == psp_name"
                            >
                                {{ $t('psp.' + psp_name) }}
                            </option>
                        </kt-form-select>
                    </kt-col>
                </kt-row>

                <kt-form-action class="mt-4">
                    <button class="btn btn-md btn-success btn-wide" type="submit" id="save_switching_btn">
                        {{ $t('btn.edit') }}
                    </button>
                </kt-form-action>
            </form>
        </div>
    </div>
</template>

<script>
import { KTApp } from '@/plugins/core/app'
import { collectiveService } from '@/common/api.service'
import { i18n } from '@/plugins/i18n'
import $ from 'jquery'

export default {
    props: {
        gateway_hashid: {
            required: true
        }
    },
    data() {
        return {
            loading: true,
            allow_user_switching: false,
            switching_status: false,
            shaparak_acceptors_status: {},
            terminal_priorities: {}
        }
    },
    computed: {
        active_psp_list() {
            return Object.keys(this.shaparak_acceptors_status).filter(
                psp => this.shaparak_acceptors_status[psp]
            )
        }
    },
    mounted() {
        collectiveService.getUserSwitchingSetting(this.gateway_hashid)
            .then(({ data }) => {
                this.allow_user_switching = data.data.allow_user_switching
                if (this.allow_user_switching) {
                    this.switching_status = data.data.switching_status
                    this.shaparak_acceptors_status = data.data.shaparak_acceptors_status || {}
                    this.terminal_priorities = { ...(data.data.terminal_priorities || {}) }
                }
            })
            .catch(() => {})
            .finally(() => {
                this.loading = false
            })
    },
    methods: {
        save() {
            const btn = $('#save_switching_btn')
            const msgDiv = $('#switching_message_div')
            KTApp.progress(btn)

            let terminals = {}
            let i = 0
            Object.values(this.terminal_priorities).forEach(psp => {
                i++
                if (this.shaparak_acceptors_status[psp]) {
                    terminals[i] = psp
                }
            })

            collectiveService.updateUserSwitchingSetting({
                gateway_hashid: this.gateway_hashid,
                switching_settings: {
                    switching_status: this.switching_status,
                    terminal_priorities: terminals
                }
            }).then(({ data }) => {
                this.showMsg(msgDiv, 'success', data.message || i18n.t('message.edit_success'))
            }).catch(({ response }) => {
                this.showMsg(msgDiv, 'danger', response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        }
    }
}
</script>
